module.exports = __webpack_public_path__ + "img/iconfont.93c5c084.svg";